// This file was generated using `pay js:run gql-v1 --type=fragment --name=LegalEntityCompanyStockArk --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {Exact} from '@stripe-internal/data-v1/schema/types';
import type {V1PermissionToken} from '@stripe-internal/data-v1/types';
import type {GraphQlDocument} from '@sail/data';

const doc = gql`
  fragment LegalEntityCompanyStockArkFragment on OpenapiLegalEntityCompanyStockData {
    ticker_symbol
    market_identifier_code
  }
`;

export const legalEntityCompanyStockArkFragment: LegalEntityCompanyStockArkFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type LegalEntityCompanyStockArkFragmentData = {
  readonly __typename: 'OpenapiLegalEntityCompanyStockData';
  readonly ticker_symbol: string | null;
  readonly market_identifier_code: string | null;
};

export type LegalEntityCompanyStockArkFragmentVariables = Exact<{
  [key: string]: never;
}>;

const legalEntityCompanyStockArkFragmentPermissions = {} as const;

doc.permissions = legalEntityCompanyStockArkFragmentPermissions;

export type LegalEntityCompanyStockArkFragmentPermissions = V1PermissionToken<
  typeof legalEntityCompanyStockArkFragmentPermissions
>;

export type LegalEntityCompanyStockArkFragmentDocument = GraphQlDocument<
  LegalEntityCompanyStockArkFragmentData,
  LegalEntityCompanyStockArkFragmentVariables,
  LegalEntityCompanyStockArkFragmentPermissions
>;
